import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField,
  Dropdown,
  Input,
  TextArea
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardBasicInfoUX = (props: any) => {
    return(
      <div
        id="CardBasicInfo"
        style={{ margin: "15px", padding: "20px", backgroundColor: "rgba(198, 235, 243, 0.2)" }}>
        <div
          id="CardBasicInfoUX-div-1"
          style={{ paddingBottom: "5px" }}>
          
          <label
            id="CardBasicInfoUX-label-2"
            style={{ fontWeight: "bold", fontSize: "18px" }}>
            {props.languageUX === "en" ? "Basic Info" : "Basic Info"}
          </label>
          <hr
            id="CardBasicInfoUX-hr-4">
          </hr>
        </div>
        <div
          className="ui form"
          id="CardBasicInfoUX-div-47">
          
          <FormGroup
            id="CardBasicInfoUX-FormGroup-158"
            inline={true}>
            <FormField
              id="CardBasicInfoUX-FormField-159"
              inline={true}
              width={16}>
              <div
                id="CardBasicInfoUX-div-160"
                style={{width:"100%"}}>
                {props.errorMessage}
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardBasicInfoUX-FormGroup-48"
            inline={true}>
            <FormField
              id="CardBasicInfoUX-FormField-51"
              inline={true}
              width={6}>
              <label
                id="CardBasicInfoUX-label-174"
                style={{minWidth:"60px", maxWidth: "60px"}}>
                {props.languageUX === "en" ? "Patient In" : "Patient In"}
              </label>
              <div
                id="CardBasicInfoUX-div-173"
                style={{width: "100%", marginRight: "1rem"}}>
                
                <DateTextBox
                  id="CardBasicInfoUX-DateTextBox-175"
                  onChange={props.handleChangeDate("patient_in_date")}
                  style={{width:"100%"}}
                  value={props.basicInfoData?.patient_in_date }>
                </DateTextBox>
              </div>
              <div
                id="CardBasicInfoUX-div-176"
                style={{width:"100%"}}>
                {props.patientInTime}
              </div>
            </FormField>
            <FormField
              id="CardBasicInfoUX-FormField-57"
              inline={true}
              width={6}>
              <label
                id="CardBasicInfoUX-label-177"
                style={{minWidth:"65px", maxWidth: "65px"}}>
                {props.languageUX === "en" ? "Patient Out" : "Patient Out"}
              </label>
              <div
                id="CardBasicInfoUX-div-178"
                style={{width: "100%", marginRight: "1rem"}}>
                
                <DateTextBox
                  id="CardBasicInfoUX-DateTextBox-179"
                  onChange={props.handleChangeDate("patient_out_date")}
                  value={props.basicInfoData?.patient_out_date }>
                </DateTextBox>
              </div>
              <div
                id="CardBasicInfoUX-div-180"
                style={{width:"100%"}}>
                {props.patientOutTime}
              </div>
            </FormField>
            <FormField
              id="CardBasicInfoUX-FormField-149"
              inline={true}
              style={{padding:0}}
              width={6}>
              <label
                id="CardBasicInfoUX-label-181"
                style={{minWidth:"90px", maxWidth: "90px"}}>
                {props.languageUX === "en" ? "Total time" : "Total time"}
              </label>
              <Input
                fluid={true}
                id="CardBasicInfoUX-Input-150"
                style={{marginRight: "0.5rem"}}
                value={props.splitTime("total_time","h")}>
              </Input>
              <label
                id="CardBasicInfoUX-label-169"
                style={{marginRight: "1rem"}}>
                {props.languageUX === "en" ? "hr." : "hr."}
              </label>
              <Input
                fluid={true}
                id="CardBasicInfoUX-Input-182"
                style={{marginRight: "0.5rem"}}
                value={props.splitTime("total_time","m")}>
              </Input>
              <label
                id="CardBasicInfoUX-label-183">
                {props.languageUX === "en" ? "min" : "min"}
              </label>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardBasicInfoUX-FormGroup-63"
            inline={true}>
            <FormField
              id="CardBasicInfoUX-FormField-65"
              inline={true}
              width={6}>
              <label
                id="CardBasicInfoUX-label-184"
                style={{minWidth:"60px", maxWidth: "60px"}}>
                {props.languageUX === "en" ? "Incision" : "Incision"}
              </label>
              <div
                id="CardBasicInfoUX-div-185"
                style={{width: "100%", marginRight: "1rem"}}>
                
                <DateTextBox
                  id="CardBasicInfoUX-DateTextBox-186"
                  onChange={props.handleChangeDate("incision_date")}
                  value={props.basicInfoData?.incision_date }>
                </DateTextBox>
              </div>
              <div
                id="CardBasicInfoUX-div-187"
                style={{width: "100%"}}>
                {props.incisionTime}
              </div>
            </FormField>
            <FormField
              id="CardBasicInfoUX-FormField-72"
              inline={true}
              width={6}>
              <label
                id="CardBasicInfoUX-label-188"
                style={{minWidth:"65px", maxWidth: "65px"}}>
                {props.languageUX === "en" ? "Closure" : "Closure"}
              </label>
              <div
                id="CardBasicInfoUX-div-189"
                style={{width: "100%", marginRight: "1rem"}}>
                
                <DateTextBox
                  id="CardBasicInfoUX-DateTextBox-190"
                  onChange={props.handleChangeDate("closure_date")}
                  value={props.basicInfoData?.closure_date }>
                </DateTextBox>
              </div>
              <div
                id="CardBasicInfoUX-div-191"
                style={{width:"100%"}}>
                {props.closureTime}
              </div>
            </FormField>
            <FormField
              id="CardBasicInfoUX-FormField-152"
              inline={true}
              style={{padding:0}}
              width={6}>
              <label
                id="CardBasicInfoUX-label-192"
                style={{minWidth:"90px", maxWidth: "90px"}}>
                {props.languageUX === "en" ? "Total Operation time" : "Total Operation time"}
              </label>
              <Input
                fluid={true}
                id="CardBasicInfoUX-Input-154"
                style={{marginRight: "0.5rem"}}
                value={props.splitTime("operation_time","h")}>
              </Input>
              <label
                id="CardBasicInfoUX-label-172"
                style={{marginRight: "1rem"}}>
                {props.languageUX === "en" ? "hr." : "hr."}
              </label>
              <Input
                fluid={true}
                id="CardBasicInfoUX-Input-193"
                style={{marginRight: "0.5rem"}}
                value={props.splitTime("operation_time","m")}>
              </Input>
              <label
                id="CardBasicInfoUX-label-194">
                {props.languageUX === "en" ? "min" : "min"}
              </label>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardBasicInfoUX-FormGroup-76"
            inline={true}>
            <FormField
              id="CardBasicInfoUX-FormField-80"
              inline={true}
              width={3}>
              <label
                id="CardBasicInfoUX-label-82">
                {props.languageUX === "en" ? "Preoperative Diagnosis" : "Preoperative Diagnosis"}
              </label>
            </FormField>
            <FormField
              id="CardBasicInfoUX-FormField-81"
              inline={true}
              width={13}>
              <TextArea
                id="CardBasicInfoUX-TextArea-195"
                onChange={props.handleChangeValue("pre_diagnosis")}
                rows={3}
                value={props.basicInfoData?.pre_diagnosis || ""}>
              </TextArea>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardBasicInfoUX-FormGroup-77"
            inline={true}>
            <FormField
              id="CardBasicInfoUX-FormField-84"
              inline={true}
              width={3}>
              <label
                id="CardBasicInfoUX-label-86">
                {props.languageUX === "en" ? "Postoperative Diagnosis" : "Postoperative Diagnosis"}
              </label>
            </FormField>
            <FormField
              id="CardBasicInfoUX-FormField-85"
              width={13}>
              <TextArea
                id="CardBasicInfoUX-TextArea-196"
                onChange={props.handleChangeValue("post_diagnosis")}
                rows={3}
                value={props.basicInfoData?.post_diagnosis || ""}>
              </TextArea>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardBasicInfoUX-FormGroup-78"
            inline={true}>
            <FormField
              id="CardBasicInfoUX-FormField-88"
              inline={true}
              width={3}>
              <label
                id="CardBasicInfoUX-label-92">
                {props.languageUX === "en" ? "Operation" : "Operation"}
              </label>
            </FormField>
            <FormField
              id="CardBasicInfoUX-FormField-90"
              width={13}>
              <TextArea
                id="CardBasicInfoUX-TextArea-197"
                onChange={props.handleChangeValue("pre_operation")}
                rows={3}
                value={props.basicInfoData?.pre_operation || ""}>
              </TextArea>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardBasicInfoUX-FormGroup-79"
            inline={true}>
            <FormField
              id="CardBasicInfoUX-FormField-89"
              inline={true}
              width={3}>
              <label
                id="CardBasicInfoUX-label-93">
                {props.languageUX === "en" ? "Anesthesia" : "Anesthesia"}
              </label>
            </FormField>
            <FormField
              id="CardBasicInfoUX-FormField-91">
              <Dropdown
                id="CardBasicInfoUX-Dropdown-95"
                onChange={props.handleChangeValue("anesthesia_method")}
                options={props.anesthesiaOptions}
                selection={true}
                value={props.basicInfoData?.anesthesia_method}>
              </Dropdown>
            </FormField>
          </FormGroup>
        </div>
        <div
          id="CardBasicInfoUX-div-96"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <div
            id="CardBasicInfoUX-div-97"
            style={{  width: "50%" }}>
            
            <div
              id="CardBasicInfoUX-div-107">
              {props?.surgeryTeam}
            </div>
          </div>
          <div
            id="CardBasicInfoUX-div-98"
            style={{ width: "50%" }}>
            
            <div
              id="CardBasicInfoUX-div-106">
              {props.anesthesiaTeam}
            </div>
          </div>
        </div>
        <div
          id="CardBasicInfoUX-div-46"
          style={{ height: "55px", paddingTop: "15px" }}>
          
          <div
            id="CardBasicInfoUX-div-42"
            style={{display:"flex",justifyContent:"flex-end"}}>
            
            <label
              id="CardBasicInfoUX-label-198">
              {props.editText}
            </label>
            <div
              id="CardBasicInfoUX-div-155"
              style={{margin:"10px"}}>
              {props.buttonSave}
            </div>
            <div
              id="CardBasicInfoUX-div-156"
              style={{margin:"10px"}}>
              {props.buttonConfirm}
            </div>
            <div
              id="CardBasicInfoUX-div-157"
              style={{margin:"10px"}}>
              {props.buttonUnconfirm}
            </div>
          </div>
        </div>
      </div>
    )
}


export default CardBasicInfoUX

export const screenPropsDefault = {"language":"TH"}

/* Date Time : Thu Nov 20 2025 07:17:11 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBasicInfo"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"15px\", padding: \"20px\", backgroundColor: \"rgba(198, 235, 243, 0.2)\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{ paddingBottom: \"5px\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "label",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "Basic Info",
          "valueEN": "Basic Info"
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-label-2"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"18px\" }"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "hr",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-hr-4"
        }
      },
      "seq": 4,
      "void": true
    },
    {
      "from": null,
      "id": 42,
      "name": "div",
      "parent": 46,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-div-42"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\",justifyContent:\"flex-end\"}"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 46,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-div-46"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"55px\", paddingTop: \"15px\" }"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": null,
      "id": 47,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-div-47"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 48,
      "name": "FormGroup",
      "parent": 47,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-FormGroup-48"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 51,
      "name": "FormField",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-FormField-51"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 57,
      "name": "FormField",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-FormField-57"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 63,
      "name": "FormGroup",
      "parent": 47,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-FormGroup-63"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 65,
      "name": "FormField",
      "parent": 63,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-FormField-65"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 72,
      "name": "FormField",
      "parent": 63,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-FormField-72"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 76,
      "name": "FormGroup",
      "parent": 47,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-FormGroup-76"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 77,
      "name": "FormGroup",
      "parent": 47,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-FormGroup-77"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 78,
      "name": "FormGroup",
      "parent": 47,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-FormGroup-78"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 79,
      "name": "FormGroup",
      "parent": 47,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-FormGroup-79"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 158,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 80,
      "name": "FormField",
      "parent": 76,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-FormField-80"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 81,
      "name": "FormField",
      "parent": 76,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-FormField-81"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "13"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": null,
      "id": 82,
      "name": "label",
      "parent": 80,
      "props": {
        "children": {
          "type": "value",
          "value": "Preoperative Diagnosis",
          "valueEN": "Preoperative Diagnosis"
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-label-82"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 84,
      "name": "FormField",
      "parent": 77,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-FormField-84"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 85,
      "name": "FormField",
      "parent": 77,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-FormField-85"
        },
        "width": {
          "type": "code",
          "value": "13"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": null,
      "id": 86,
      "name": "label",
      "parent": 84,
      "props": {
        "children": {
          "type": "value",
          "value": "Postoperative Diagnosis",
          "valueEN": "Postoperative Diagnosis"
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-label-86"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 88,
      "name": "FormField",
      "parent": 78,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-FormField-88"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 89,
      "name": "FormField",
      "parent": 79,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-FormField-89"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 90,
      "name": "FormField",
      "parent": 78,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-FormField-90"
        },
        "width": {
          "type": "code",
          "value": "13"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 91,
      "name": "FormField",
      "parent": 79,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-FormField-91"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": null,
      "id": 92,
      "name": "label",
      "parent": 88,
      "props": {
        "children": {
          "type": "value",
          "value": "Operation",
          "valueEN": "Operation"
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-label-92"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": null,
      "id": 93,
      "name": "label",
      "parent": 89,
      "props": {
        "children": {
          "type": "value",
          "value": "Anesthesia",
          "valueEN": "Anesthesia"
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-label-93"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 95,
      "name": "Dropdown",
      "parent": 91,
      "props": {
        "disabled": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-Dropdown-95"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"anesthesia_method\")"
        },
        "options": {
          "type": "code",
          "value": "props.anesthesiaOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.basicInfoData?.anesthesia_method"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": null,
      "id": 96,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-div-96"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 97,
      "name": "div",
      "parent": 96,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-div-97"
        },
        "style": {
          "type": "code",
          "value": "{  width: \"50%\" }"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": null,
      "id": 98,
      "name": "div",
      "parent": 96,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-div-98"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"50%\" }"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": null,
      "id": 106,
      "name": "div",
      "parent": 98,
      "props": {
        "children": {
          "type": "code",
          "value": "props.anesthesiaTeam"
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-div-106"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": null,
      "id": 107,
      "name": "div",
      "parent": 97,
      "props": {
        "children": {
          "type": "code",
          "value": "props?.surgeryTeam"
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-div-107"
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 149,
      "name": "FormField",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-FormField-149"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{padding:0}"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 149,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 150,
      "name": "Input",
      "parent": 149,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-Input-150"
        },
        "onChange": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.5rem\"}"
        },
        "value": {
          "type": "code",
          "value": "props.splitTime(\"total_time\",\"h\")"
        }
      },
      "seq": 169,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 152,
      "name": "FormField",
      "parent": 63,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-FormField-152"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{padding:0}"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 152,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 154,
      "name": "Input",
      "parent": 152,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-Input-154"
        },
        "onChange": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.5rem\"}"
        },
        "value": {
          "type": "code",
          "value": "props.splitTime(\"operation_time\",\"h\")"
        }
      },
      "seq": 172,
      "void": false
    },
    {
      "from": null,
      "id": 155,
      "name": "div",
      "parent": 42,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSave"
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-div-155"
        },
        "style": {
          "type": "code",
          "value": "{margin:\"10px\"}"
        }
      },
      "seq": 156,
      "void": false
    },
    {
      "from": null,
      "id": 156,
      "name": "div",
      "parent": 42,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonConfirm"
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-div-156"
        },
        "style": {
          "type": "code",
          "value": "{margin:\"10px\"}"
        }
      },
      "seq": 157,
      "void": false
    },
    {
      "from": null,
      "id": 157,
      "name": "div",
      "parent": 42,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonUnconfirm"
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-div-157"
        },
        "style": {
          "type": "code",
          "value": "{margin:\"10px\"}"
        }
      },
      "seq": 198,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 158,
      "name": "FormGroup",
      "parent": 47,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-FormGroup-158"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 159,
      "name": "FormField",
      "parent": 158,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-FormField-159"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 159,
      "void": false
    },
    {
      "from": null,
      "id": 160,
      "name": "div",
      "parent": 159,
      "props": {
        "children": {
          "type": "code",
          "value": "props.errorMessage"
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-div-160"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        }
      },
      "seq": 160,
      "void": false
    },
    {
      "from": null,
      "id": 169,
      "name": "label",
      "parent": 149,
      "props": {
        "children": {
          "type": "value",
          "value": "hr.",
          "valueEN": "hr."
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-label-169"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"1rem\"}"
        }
      },
      "seq": 181,
      "void": false
    },
    {
      "from": null,
      "id": 172,
      "name": "label",
      "parent": 152,
      "props": {
        "children": {
          "type": "value",
          "value": "hr.",
          "valueEN": "hr."
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-label-172"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"1rem\"}"
        }
      },
      "seq": 192,
      "void": false
    },
    {
      "from": null,
      "id": 173,
      "name": "div",
      "parent": 51,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-div-173"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", marginRight: \"1rem\"}"
        }
      },
      "seq": 174,
      "void": false
    },
    {
      "from": null,
      "id": 174,
      "name": "label",
      "parent": 51,
      "props": {
        "children": {
          "type": "value",
          "value": "Patient In",
          "valueEN": "Patient In"
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-label-174"
        },
        "style": {
          "type": "code",
          "value": "{minWidth:\"60px\", maxWidth: \"60px\"}"
        }
      },
      "seq": 173,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 175,
      "name": "DateTextBox",
      "parent": 173,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-DateTextBox-175"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeDate(\"patient_in_date\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.basicInfoData?.patient_in_date "
        }
      },
      "seq": 175,
      "void": false
    },
    {
      "from": null,
      "id": 176,
      "name": "div",
      "parent": 51,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientInTime"
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-div-176"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        }
      },
      "seq": 176,
      "void": false
    },
    {
      "from": null,
      "id": 177,
      "name": "label",
      "parent": 57,
      "props": {
        "children": {
          "type": "value",
          "value": "Patient Out",
          "valueEN": "Patient Out"
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-label-177"
        },
        "style": {
          "type": "code",
          "value": "{minWidth:\"65px\", maxWidth: \"65px\"}"
        }
      },
      "seq": 177,
      "void": false
    },
    {
      "from": null,
      "id": 178,
      "name": "div",
      "parent": 57,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-div-178"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", marginRight: \"1rem\"}"
        }
      },
      "seq": 178,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 179,
      "name": "DateTextBox",
      "parent": 178,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-DateTextBox-179"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeDate(\"patient_out_date\")"
        },
        "value": {
          "type": "code",
          "value": "props.basicInfoData?.patient_out_date "
        }
      },
      "seq": 179,
      "void": false
    },
    {
      "from": null,
      "id": 180,
      "name": "div",
      "parent": 57,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientOutTime"
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-div-180"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        }
      },
      "seq": 180,
      "void": false
    },
    {
      "from": null,
      "id": 181,
      "name": "label",
      "parent": 149,
      "props": {
        "children": {
          "type": "value",
          "value": "Total time",
          "valueEN": "Total time"
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-label-181"
        },
        "style": {
          "type": "code",
          "value": "{minWidth:\"90px\", maxWidth: \"90px\"}"
        }
      },
      "seq": 150,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 182,
      "name": "Input",
      "parent": 149,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-Input-182"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.5rem\"}"
        },
        "value": {
          "type": "code",
          "value": "props.splitTime(\"total_time\",\"m\")"
        }
      },
      "seq": 182,
      "void": false
    },
    {
      "from": null,
      "id": 183,
      "name": "label",
      "parent": 149,
      "props": {
        "children": {
          "type": "value",
          "value": "min",
          "valueEN": "min"
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-label-183"
        }
      },
      "seq": 183,
      "void": false
    },
    {
      "from": null,
      "id": 184,
      "name": "label",
      "parent": 65,
      "props": {
        "children": {
          "type": "value",
          "value": "Incision",
          "valueEN": "Incision"
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-label-184"
        },
        "style": {
          "type": "code",
          "value": "{minWidth:\"60px\", maxWidth: \"60px\"}"
        }
      },
      "seq": 184,
      "void": false
    },
    {
      "from": null,
      "id": 185,
      "name": "div",
      "parent": 65,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-div-185"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", marginRight: \"1rem\"}"
        }
      },
      "seq": 185,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 186,
      "name": "DateTextBox",
      "parent": 185,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-DateTextBox-186"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeDate(\"incision_date\")"
        },
        "value": {
          "type": "code",
          "value": "props.basicInfoData?.incision_date "
        }
      },
      "seq": 186,
      "void": false
    },
    {
      "from": null,
      "id": 187,
      "name": "div",
      "parent": 65,
      "props": {
        "children": {
          "type": "code",
          "value": "props.incisionTime"
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-div-187"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 187,
      "void": false
    },
    {
      "from": null,
      "id": 188,
      "name": "label",
      "parent": 72,
      "props": {
        "children": {
          "type": "value",
          "value": "Closure",
          "valueEN": "Closure"
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-label-188"
        },
        "style": {
          "type": "code",
          "value": "{minWidth:\"65px\", maxWidth: \"65px\"}"
        }
      },
      "seq": 188,
      "void": false
    },
    {
      "from": null,
      "id": 189,
      "name": "div",
      "parent": 72,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-div-189"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", marginRight: \"1rem\"}"
        }
      },
      "seq": 189,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 190,
      "name": "DateTextBox",
      "parent": 189,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-DateTextBox-190"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeDate(\"closure_date\")"
        },
        "value": {
          "type": "code",
          "value": "props.basicInfoData?.closure_date "
        }
      },
      "seq": 190,
      "void": false
    },
    {
      "from": null,
      "id": 191,
      "name": "div",
      "parent": 72,
      "props": {
        "children": {
          "type": "code",
          "value": "props.closureTime"
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-div-191"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        }
      },
      "seq": 191,
      "void": false
    },
    {
      "from": null,
      "id": 192,
      "name": "label",
      "parent": 152,
      "props": {
        "children": {
          "type": "value",
          "value": "Total Operation time",
          "valueEN": "Total Operation time"
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-label-192"
        },
        "style": {
          "type": "code",
          "value": "{minWidth:\"90px\", maxWidth: \"90px\"}"
        }
      },
      "seq": 154,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 193,
      "name": "Input",
      "parent": 152,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-Input-193"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.5rem\"}"
        },
        "value": {
          "type": "code",
          "value": "props.splitTime(\"operation_time\",\"m\")"
        }
      },
      "seq": 193,
      "void": false
    },
    {
      "from": null,
      "id": 194,
      "name": "label",
      "parent": 152,
      "props": {
        "children": {
          "type": "value",
          "value": "min",
          "valueEN": "min"
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-label-194"
        }
      },
      "seq": 194,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 195,
      "name": "TextArea",
      "parent": 81,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-TextArea-195"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"pre_diagnosis\")"
        },
        "rows": {
          "type": "code",
          "value": "3"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.basicInfoData?.pre_diagnosis || \"\""
        }
      },
      "seq": 195,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 196,
      "name": "TextArea",
      "parent": 85,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-TextArea-196"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"post_diagnosis\")"
        },
        "rows": {
          "type": "code",
          "value": "3"
        },
        "value": {
          "type": "code",
          "value": "props.basicInfoData?.post_diagnosis || \"\""
        }
      },
      "seq": 196,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 197,
      "name": "TextArea",
      "parent": 90,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-TextArea-197"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"pre_operation\")"
        },
        "rows": {
          "type": "code",
          "value": "3"
        },
        "value": {
          "type": "code",
          "value": "props.basicInfoData?.pre_operation || \"\""
        }
      },
      "seq": 197,
      "void": true
    },
    {
      "from": null,
      "id": 198,
      "name": "label",
      "parent": 42,
      "props": {
        "children": {
          "type": "code",
          "value": "props.editText"
        },
        "id": {
          "type": "value",
          "value": "CardBasicInfoUX-label-198"
        }
      },
      "seq": 155,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardBasicInfoUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "TH"
  },
  "width": 90
}

*********************************************************************************** */
